import '../styles/index.scss';
import 'slick-carousel/slick/slick';
import 'bootstrap';
import header from './header';
import promoTimer from './blocks/promo-timer';
import productSlider from './blocks/product-slider';
import heroSlider from './blocks/hero-slider';
import categoryFilters from './blocks/category-filters';
import productVariations from './blocks/product-variations';
import productPage from './blocks/product-page';
import cartDrawer from './blocks/cart-drawer';
import authLayout from './blocks/auth-layout';
import search from './blocks/search';
import aboutTimeline from './blocks/about-timeline';
import bundle from './blocks/bundle';

class Main {
    constructor() {
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onResize();
        this.onScroll();
        window.jQuery = window.$ = $;
    }

    onDocumentLoad() {
        window.addEventListener("load", (event) => {
        });
    }

    onDOMLoaded() {
        document.addEventListener("DOMContentLoaded", (event) => {
            header.init();
            promoTimer.init();
            productSlider.init();
            heroSlider.init();
            categoryFilters.init();
            productVariations.init();
            productPage.init();
            cartDrawer.init();
            authLayout.init();
            search.init();
            aboutTimeline.init();
            bundle.init();
        });
    }

    onResize() {
        window.addEventListener('resize', (event) => {

        });
    }
    onScroll() {
        window.addEventListener('scroll', (event) => {

        });
    }

}

new Main();


